import {
    Typography,
    useTheme,
    Box,
    useMediaQuery,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';
import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import Reporting from '../HomePage/reportingSmall';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



// Молодіжним просторам та центрам
const ForYouthSpacesAndCenters = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Партнерам", urlSlug: "/for-partners" },
        { name: "Молодіжним просторам та центрам", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Молодіжним просторам та центрам`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ mb: { xs: "43px", lg: "120px" } }}>
                <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Box>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", lg: "36px" }} lineHeight="38px">
                    Молодіжним просторам та центрам
                </Typography>
                <Typography variant="h5" fontFamily="Fixel Display, sans-serif" fontWeight="600" sx={{ mt: { xs: "14px", lg: "34px" }, mb: { xs: "43px", lg: "100px" } }}>
                    Якщо ваш молодіжний центр прагне стати майданчиком для творчості, інновацій та культурного розвитку, ми готові до співпраці! Ми організовуємо події, які залучають молодь до неформального навчання, обміну ідеями та вивчення історії через інтерактивні форми. Спільно ми можемо створити заходи, які не лише зацікавлять молодих людей, але й сприятимуть їхньому особистісному зростанню та формуванню активної громадянської позиції.
                    <br /><br />
                    Ваша підтримка як простору для наших ініціатив дозволить нам розширити аудиторію, а вам — запропонувати нові формати заходів для вашої спільноти. Разом ми надихатимемо молодь творити та розширювати свій світогляд.
                </Typography>
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Наша звітність */}
                <Reporting />
            </Box>
        </>
    )
}

export default ForYouthSpacesAndCenters